import { useEffect, useState } from "react";
import { api, unwrap } from "@/lib/api";

export function useStaff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/staff").then(r => setStaff(unwrap(r) || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return { staff, loading };
}

export function useServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/services").then(r => setServices(unwrap(r) || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return { services, loading };
}

export function useInventory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/inventory").then(r => setItems(unwrap(r) || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return { items, loading };
}
